import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import DiscountGroup from "../entities/discountGroup";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";

class DiscountGroupDB extends FirestorePipe {
  public static readonly colName = 'DiscountGroup';

  constructor(idEstab: string, idStore: string) {
    if (!idEstab || !idStore) {
      throw new Error('Informe o id da loja e do estabelecimento');
    }

    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${DiscountGroupDB.colName}`);
  }

  public create(data: DiscountGroup): Promise<any> {
    return this._create(data);
  }

  public update(id: string, data: Partial<DiscountGroup>): Promise<any> {
    return this._update(id, data);
  }

  public delete(id: string): Promise<any> {
    return this._delete(id);
  }

  public getAll(...params: QueryConstraint[]): Promise<DiscountGroup[]> {
    return this._getAll<DiscountGroup>(...params);
  }

  public get(id: string): Promise<DiscountGroup> {
    return this._get(id);
  }

  public on(listener: (data: DiscountGroup[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default DiscountGroupDB;
